<template>
  <div class="empty-youtube-views-page"
       :class="searchesPageStyles">
    <div class="views">
      <div v-if="$mq !== 'mobile'"
           class="views-icon">
        <icon-eye width="100"
                  height="100"
                  iconColor="#8067b7" />
      </div>
    </div>

    {{ $t("tabs.youtube.emptyViews") }}

    <base-button class="retry-button"
                 color="primary"
                 :loading="loading"
                 @click="$emit('retry')">
      {{ $t("tabs.tapToRetry") }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        required: true,
        type: Boolean
      }
    },

    computed: {
      searchesPageStyles() {
        return {
          'empty-youtube-views-page-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-youtube-views-page {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .views {
      text-align: center;

      &-icon {
        background: color.adjust(map.get($colors, primary), $lightness: 40%);

        padding: 50px;
        margin-bottom: 20px;
        border-radius: 50%;

        display: flex;
        justify-content: center;
      }
    }

    .retry-button {
      margin: 12px auto;
    }
  }

  .empty-youtube-views-page-mobile {
    .views {
      &-icon {
        padding: 40px;
        margin-bottom: 10px;
      }

      .retry-button {
        margin: 10px auto;
      }
    }
  }
</style>
